import React, { useState, useEffect, useContext } from 'react';
import { AuthContext, TasksContext } from '@/App';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Crown, X } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SubscriptionBanner = () => {
  const { auth } = useContext(AuthContext);
  const { tasksVersion } = useContext(TasksContext);
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/subscription/status`, { headers: { Authorization: `Bearer ${auth.token}` } })
      .then(r => setSub(r.data)).catch(() => {});
  }, [auth.token, tasksVersion]);

  if (!sub || dismissed || sub.plan_source === 'paid' || sub.plan_source === 'demo') return null;

  const isTrial = sub.plan_source === 'trial';
  const text = isTrial
    ? <><span className="font-semibold text-amber-300">Pro trial: </span>{sub.days_remaining > 0 ? `${sub.days_remaining} day${sub.days_remaining > 1 ? 's' : ''} left` : 'ends today'} — then the Free plan ({sub.tasks_this_week} of 20 tasks used this week).</>
    : <><span className="font-semibold text-amber-300">Free plan: </span>{sub.tasks_this_week} of {sub.task_limit} tasks used this week. Pro unlocks unlimited tasks, Non-Negotiables, Schedule Health and Life Intelligence.</>;

  return (
    <div className="bg-amber-500/10 border-b border-amber-400/20" data-testid={isTrial ? 'trial-banner' : 'free-plan-banner'}>
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Crown size={18} className="text-amber-300 flex-shrink-0" />
          <p className="text-sm body-font text-gray-300" data-testid="plan-banner-text">{text}</p>
        </div>
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="sm" onClick={() => navigate('/settings')}
            className="text-amber-300 hover:bg-amber-500/10" data-testid="subscribe-from-banner">
            Go Pro · $5/mo
          </Button>
          <Button variant="ghost" size="icon" onClick={() => setDismissed(true)}
            className="text-amber-300 hover:bg-amber-500/10" data-testid="dismiss-banner">
            <X size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;
